import { useEffect, useState } from 'react';
import type { IEpisodeCategoryBasic } from '../../../../../common/interfaces/episodeCategory';
import type {
    IServiceGroupWithProfileSettings,
    IServicesByServiceGroupForEpisodeCategory,
} from '../../../../../common/interfaces/servicesByServiceGroupForEpisodeCategory';
import type { ISelectableOption } from '../../../interfaces/selectableOption';
import type { ISelectableCard } from '../../organizations/organizationAddCarePath/OrganizationAddCarePathContent';
import { translateKey } from '../../../../translate';
import { SelectableOptionsCard } from '../cards/SelectableOptionsCard';

interface IChooseServiceGroupsProps {
    episodeCategory: IEpisodeCategoryBasic;
    serviceGroupMembershipsGroupedByEpisodeCategories: IServicesByServiceGroupForEpisodeCategory[];
    serviceGroups?: IServiceGroupWithProfileSettings[];
    updateState: (serviceGroups?: IServiceGroupWithProfileSettings[]) => void;
}

export function ChooseServiceGroups(props: IChooseServiceGroupsProps) {
    const [card, setCard] = useState<ISelectableCard>();
    const [episodeCategoryServiceGroups, setEpisodeCategoryServiceGroups] =
        useState<IServicesByServiceGroupForEpisodeCategory>();

    useEffect(() => {
        createChooseServiceGroupsCard();
    }, [props.episodeCategory, props.serviceGroups]);

    if (!card) {
        return null;
    }

    return (
        <SelectableOptionsCard
            {...card}
            onChange={onChange}
        />
    );

    function onChange(id: string, sequence: number) {
        const serviceGroups = props.serviceGroups ? [...props.serviceGroups] : [];
        const selectableOption = card?.selectableOptions.find((option) => option.id === id);
        if (selectableOption) {
            const selectedServiceGroup = episodeCategoryServiceGroups?.serviceGroups.find(
                (serviceGroup) => serviceGroup.id === selectableOption.id
            );
            if (selectedServiceGroup) {
                const index = serviceGroups.findIndex((group) => group.id === selectedServiceGroup.id);
                index === -1 ? serviceGroups.push(selectedServiceGroup) : serviceGroups.splice(index, 1);
            }
        }
        props.updateState(serviceGroups);
    }

    function createChooseServiceGroupsCard() {
        const serviceGroupsByEpisodeCategory = props.serviceGroupMembershipsGroupedByEpisodeCategories.find(
            (service) => service.episodeCategory.name === props.episodeCategory.name
        );
        setEpisodeCategoryServiceGroups(serviceGroupsByEpisodeCategory);

        if (serviceGroupsByEpisodeCategory) {
            const selectableOptions = serviceGroupsByEpisodeCategory.serviceGroups.map(
                (serviceGroup) =>
                    ({
                        name: serviceGroup.name,
                        displayName: serviceGroup.name,
                        id: serviceGroup.id,
                        selected: props.serviceGroups?.some((group) => group.id === serviceGroup.id),
                    }) as ISelectableOption
            );

            const serviceGroupCard: ISelectableCard = {
                title: translateKey('carePath.whichSubcategoryToAdd'),
                subtitle: translateKey('carePath.multipleChoicesPossible'),
                sequence: 0,
                selectableOptions,
            };
            setCard(serviceGroupCard);
        }
    }
}
